import { Box, Button, Flex } from '@mantine/core'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import Confetti from 'react-confetti'

import { useTranslation } from '@flecto/translations'

import { CardOrderConfirmation } from '../../components/CardOrderConfirmation/CardOrderConfirmation'
import { CardOrderContactStore } from '../../components/CardOrderContactStore/CardOrderContactStore'
import { CardOrderDetails } from '../../components/CardOrderDetails/CardOrderDetails'
import { CardOrderSummary } from '../../components/CardOrderSummary/CardOrderSummary'
import { Page } from '../../components/Page/Page'
import { useStoreDetails } from '../../hooks/useStoreDetails'
import { useStoreLocalStorage } from '../../hooks/useStoreLocalStorage'
import { useStoreOrderId } from '../../hooks/useStoreOrderId'
import { useStorePathBuilder } from '../../hooks/useStorePathBuilder'
import styles from './styles.module.css'

export function PageConfirmation() {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-confirmation',
  })
  const [isConfettiRunning, setIsConfettiRunning] = useState(true)

  const { getOrderConfirmed } = useStoreLocalStorage()

  const router = useRouter()
  const path = useStorePathBuilder()
  const store = useStoreDetails()
  const order = getOrderConfirmed()
  const orderId = useStoreOrderId(order)

  useEffect(() => {
    if (!order) {
      router.push(path('/'))
      return
    }

    setTimeout(() => {
      setIsConfettiRunning(false)
    }, 3000)
  }, [])

  if (!order) {
    return
  }

  return (
    <Page
      htmlTitle={t('html_title', { store: store?.name })}
      htmlMetaDescription={t('html_meta_description')}
      htmlMetaOgTitle={t('html_meta_og_title', { store: store?.name })}
      htmlMetaOgDescription={t('html_meta_og_description')}
      withHeaderBasket={false}
      withHeaderDates={false}
      enableRobots={false}
    >
      <Confetti recycle={isConfettiRunning} run />
      <Page.Section
        title={
          <Box className={styles.intro}>
            <Box className={styles.title}>{t('title')}</Box>
            <Button size='lg' onClick={() => router.push(path('/'))}>
              {t('button_back')}
            </Button>
          </Box>
        }
        subtitle={
          <Box className={styles.subtitle}>
            {t('subtitle', { order: orderId })}
          </Box>
        }
      >
        <Box className={styles.section}>
          <Flex direction='column' gap='md'>
            <CardOrderConfirmation
              order={order}
              className={styles.cardOrderConfirmation}
            />
            <CardOrderSummary order={order} />
            <CardOrderDetails
              order={order}
              className={styles.cardOrderDetails}
            />
          </Flex>
          <CardOrderContactStore className={styles.cardRight} order={order} />
        </Box>
      </Page.Section>
    </Page>
  )
}
